import type { Gender, LeaveTypeId } from '@lms/shared-types'

/**
 * Maps gender-restricted leave types to the set of genders that may apply
 * for them. Leave types absent from this map are unrestricted.
 *
 * Server-side route (Task 16) is the authoritative gate — this predicate
 * is a UX filter only, preventing ineligible options from appearing in the
 * picker.
 */
const APPLICABLE_GENDERS: Partial<Record<LeaveTypeId, ReadonlySet<Gender>>> = {
  maternity: new Set<Gender>(['F', 'X']),
  paternity: new Set<Gender>(['M', 'X']),
}

/**
 * Returns true when `gender` is eligible to apply for the given leave type.
 *
 * @example
 * isApplicable('maternity', 'M') // false
 * isApplicable('maternity', 'F') // true
 * isApplicable('annual',    'M') // true — unrestricted type
 */
export function isApplicable(code: LeaveTypeId, gender: Gender): boolean {
  const allowed = APPLICABLE_GENDERS[code]
  return !allowed || allowed.has(gender)
}
